import {
  STATUS_SUBMITTED,
  STATUS_PRE_QUALIFIED,
  STATUS_DOCUMENTS_SIGNED,
  STATUS_FUNDING,
  STATUS_UNDER_REVIEW,
  STATUS_WITHDRAW,
  STATUS_DECLINED,
  STATUS_CLEAR_TO_CLOSE_COMPLETED,
  STATUS_APPROVED_NOT_ACCEPTED,
  STATUS_APPROVED,
  STATUS_APPLICATION_STARTED,
  STATUS_DENIAL_UNDER_REVIEW,
  STATUS_CLOSED,
  STATUS_RECOMMENDED_APPROVE,
  STATUS_RECOMMENDED_DECLINE,
  STATUS_CLOSED_FOR_INCOMPLETENESS,
  STATUS_APPLICATION_APPROVED,
  STATUS_LOAN_CLOSED,
  STATUS_REQUEST_APPROVAL,
  STATUS_CREDIT_APPROVAL
} from 'src/services/constants';
import {
  ADVISOR_LENDING_LIMIT_EXCEEDS,
  ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
  ADVISOR_LOAN_TERMS_UNDER_12_MONTHS_OF_POLICY,
} from 'src/features/RBAC/Rules/permissionData';

const stagePreQualifiedHeloc = {
  name: STATUS_PRE_QUALIFIED,
  display_name: STATUS_RECOMMENDED_APPROVE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      permission: ADVISOR_LOAN_TERMS_UNDER_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPLICATION_APPROVED,
          display_name: STATUS_APPLICATION_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    }
  ]
}

const stageUnderReviewHeloc = {
  name: STATUS_UNDER_REVIEW,
  display_name: STATUS_RECOMMENDED_DECLINE,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LOAN_TERMS_EXCEEDED_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        }
      ]
    },
    {
      permission: ADVISOR_LOAN_TERMS_UNDER_12_MONTHS_OF_POLICY,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        }
      ]
    },
    {
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW
        },
        {
          name: STATUS_CLOSED_FOR_INCOMPLETENESS,
          display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        }
      ]
    }
  ]
}

const stageDenialUnderReviewHelocAdmin = {
  name: STATUS_DENIAL_UNDER_REVIEW,
  display_name: STATUS_DENIAL_UNDER_REVIEW,
  children: [
    {
      stages: [
        {
          name: STATUS_PRE_QUALIFIED,
          display_name: STATUS_RECOMMENDED_APPROVE,
        },
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
        {
          name: STATUS_DECLINED,
          display_name: STATUS_DECLINED,
        }
      ]
    }
  ]
}

const stageDenialUnderReviewHeloc = {
  name: STATUS_DENIAL_UNDER_REVIEW,
  display_name: STATUS_DENIAL_UNDER_REVIEW,
  children: [
    {
      stages: [
        {
          name: STATUS_UNDER_REVIEW,
          display_name: STATUS_RECOMMENDED_DECLINE,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        }
      ]
    }
  ]
}

const stageApproval = {
  name: STATUS_REQUEST_APPROVAL,
  display_name: STATUS_REQUEST_APPROVAL,
  order_id: 2,
  children: [
    {
      permission: ADVISOR_LENDING_LIMIT_EXCEEDS,
      stages: [
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        }
      ]
    },
    {
      stages: [
        {
          name: STATUS_APPLICATION_APPROVED,
          display_name: STATUS_APPLICATION_APPROVED,
          order: 5
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]
    },
  ]
}

const stageCreditApproval = {
  name: STATUS_CREDIT_APPROVAL,
  display_name: STATUS_CREDIT_APPROVAL,
  order_id: 2,
  children: [
    {
      stages: [
        {
          name: STATUS_APPLICATION_APPROVED,
          display_name: STATUS_APPLICATION_APPROVED,
          order: 5,
        },
        {
          name: STATUS_WITHDRAW,
          display_name: STATUS_WITHDRAW,
        },
        {
          name: STATUS_APPROVED_NOT_ACCEPTED,
          display_name: STATUS_APPROVED_NOT_ACCEPTED,
        },
        {
          name: STATUS_DENIAL_UNDER_REVIEW,
          display_name: STATUS_DENIAL_UNDER_REVIEW,
        },
        {
          name: STATUS_SUBMITTED,
          display_name: STATUS_SUBMITTED,
        },
      ]

    }
  ]
}


export const mkResidentialMortgageStageforAdmin = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_PRE_QUALIFIED,
            "display_name": STATUS_RECOMMENDED_APPROVE,
          },
          {
            "name": STATUS_UNDER_REVIEW,
            "display_name": STATUS_RECOMMENDED_DECLINE,
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_WITHDRAW,
    "display_name": STATUS_WITHDRAW
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DENIAL_UNDER_REVIEW,
            "display_name": STATUS_DENIAL_UNDER_REVIEW
          },
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          },
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_DOCUMENTS_SIGNED,
            "display_name": STATUS_DOCUMENTS_SIGNED
          },
          {
            "name": STATUS_FUNDING,
            "display_name": STATUS_FUNDING
          }
        ]
      }
    ],
    "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
    "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_LOAN_CLOSED,
    "display_name": STATUS_LOAN_CLOSED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DENIAL_UNDER_REVIEW,
            "display_name": STATUS_DENIAL_UNDER_REVIEW
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_APPROVED,
    "display_name": STATUS_APPLICATION_APPROVED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_APPROVED_NOT_ACCEPTED,
    "display_name": STATUS_APPROVED_NOT_ACCEPTED
  },
  {
    name: STATUS_DOCUMENTS_SIGNED,
    display_name: STATUS_DOCUMENTS_SIGNED,
    children: [
      {
        stages: [
          {
            name: STATUS_FUNDING,
            display_name: STATUS_FUNDING,
          }
        ]
      },
    ]
  },
  {
    name: STATUS_FUNDING,
    display_name: STATUS_FUNDING,
    children: [
      {
        stages: [
          {
            name: STATUS_LOAN_CLOSED,
            display_name: STATUS_LOAN_CLOSED,
          }
        ]
      },
    ]
  },
  stageUnderReviewHeloc,
  stageDenialUnderReviewHelocAdmin,
  stagePreQualifiedHeloc,
  stageApproval,
  stageCreditApproval
]

// Applies to loan officers
export const mkResidentialMortgageStageforLO = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DENIAL_UNDER_REVIEW,
            "display_name": STATUS_DENIAL_UNDER_REVIEW
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_PRE_QUALIFIED,
            "display_name": STATUS_RECOMMENDED_APPROVE,
          },
          {
            "name": STATUS_UNDER_REVIEW,
            "display_name": STATUS_RECOMMENDED_DECLINE,
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DENIAL_UNDER_REVIEW,
            "display_name": STATUS_DENIAL_UNDER_REVIEW
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_WITHDRAW,
    "display_name": STATUS_WITHDRAW
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DENIAL_UNDER_REVIEW,
            "display_name": STATUS_DENIAL_UNDER_REVIEW
          },
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          },
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          },
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_DOCUMENTS_SIGNED,
            "display_name": STATUS_DOCUMENTS_SIGNED
          },
          {
            "name": STATUS_FUNDING,
            "display_name": STATUS_FUNDING
          }
        ]
      }
    ],
    "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
    "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_LOAN_CLOSED,
    "display_name": STATUS_LOAN_CLOSED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          },
          {
            "name": STATUS_APPROVED_NOT_ACCEPTED,
            "display_name": STATUS_APPROVED_NOT_ACCEPTED
          },
          {
            "name": STATUS_WITHDRAW,
            "display_name": STATUS_WITHDRAW
          },
          {
            "name": STATUS_DENIAL_UNDER_REVIEW,
            "display_name": STATUS_DENIAL_UNDER_REVIEW
          },
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_APPROVED,
    "display_name": STATUS_APPLICATION_APPROVED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_APPROVED_NOT_ACCEPTED,
    "display_name": STATUS_APPROVED_NOT_ACCEPTED
  },
  {
    name: STATUS_DOCUMENTS_SIGNED,
    display_name: STATUS_DOCUMENTS_SIGNED,
    children: [
      {
        stages: [
          {
            name: STATUS_FUNDING,
            display_name: STATUS_FUNDING,
          }
        ]
      },
    ]
  },
  {
    name: STATUS_FUNDING,
    display_name: STATUS_FUNDING,
    children: [
      {
        stages: [
          {
            name: STATUS_LOAN_CLOSED,
            display_name: STATUS_LOAN_CLOSED,
          }
        ]
      },
    ]
  },
  stageUnderReviewHeloc,
  stagePreQualifiedHeloc,
  stageDenialUnderReviewHeloc,
  stageApproval,
  stageCreditApproval
]

export const mkResidentialMortgageApplicantStage = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_APPROVED,
            "display_name": STATUS_APPLICATION_APPROVED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
            "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_APPROVED,
    "display_name": STATUS_APPLICATION_APPROVED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_DOCUMENTS_SIGNED,
            "display_name": STATUS_DOCUMENTS_SIGNED
          }
        ]
      }
    ],
    "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
    "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_FUNDING,
            "display_name": STATUS_FUNDING
          }
        ]
      }
    ],
    "name": STATUS_DOCUMENTS_SIGNED,
    "display_name": STATUS_DOCUMENTS_SIGNED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_LOAN_CLOSED,
            "display_name": STATUS_LOAN_CLOSED
          }
        ]
      }
    ],
    "name": STATUS_FUNDING,
    "display_name": STATUS_FUNDING
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_LOAN_CLOSED,
    "display_name": STATUS_LOAN_CLOSED
  }
]

export const mkApplicantLoanStagesForDeposit = [
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_UNDER_REVIEW,
    "display_name": STATUS_UNDER_REVIEW
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_APPROVED,
    "display_name": STATUS_APPROVED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_CLOSED,
    "display_name": STATUS_CLOSED
  }
]

export const mkApplicantLoanStagesForFundloan = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  }
]

export const mkAdvisorLoanStagesForFundloan = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_STARTED,
    "display_name": STATUS_APPLICATION_STARTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_SUBMITTED,
    "display_name": STATUS_SUBMITTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_SUBMITTED,
            "display_name": STATUS_SUBMITTED
          },
          {
            "name": STATUS_APPLICATION_STARTED,
            "display_name": STATUS_APPLICATION_STARTED
          }
        ]
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  }
]

